var exports = {
  "D": "PlayButton__8g3Kj4",
};

module.exports = exports;
